import Flatpickr from "react-flatpickr";
import { InterruptionReferenceSelector } from "../../selectors/interruption/InterruptionReferenceSelector";
import { CreateAdditionalHoursModalViewProps } from "./CreateAdditionalHoursModalView.Props";

export const CreateAdditionalHoursModalView = ({
  labels,
  startHour,
  endHour,
  observations,
  referenceTypeId,
  isExtra,
  hourTypeList,
  tableRows,
  totalRegisteredHours,
  onStartHourChange,
  onEndHourChange,
  onObservationsChange,
  onReferenceChange,
  onHourTypeChange,
  onIsExtraChange,
  onAddHour,
  onDeleteHour,
}: CreateAdditionalHoursModalViewProps) => {
  const flatpickrTimeOptions = {
    enableTime: true,
    noCalendar: true,
    dateFormat: "H:i" as const,
  };

  return (
    <div className="modal-body text-black p-0 my-1">
      <div className="mb-4">
        <div className="row g-3 mb-3">
          <div className="col-md-6 d-flex flex-column gap-1">
            <div>
              <label htmlFor="startDate" className="form-label fw-bold mb-1">
                {labels.starDate}
              </label>
              <Flatpickr
                id="startDate"
                className="form-control text-black w-100"
                value={startHour}
                onChange={onStartHourChange}
                options={flatpickrTimeOptions}
              />
            </div>

            <div>
              <label htmlFor="endDate" className="form-label fw-bold mb-1">
                {labels.endDate}
              </label>
              <Flatpickr
                id="endDate"
                className="form-control text-black w-100"
                value={endHour}
                onChange={onEndHourChange}
                options={flatpickrTimeOptions}
              />
            </div>
          </div>

          <div className="col-md-6">
            <label
              htmlFor="input-observations"
              className="form-label fw-bold mb-1"
            >
              {labels.observationsLabel}
            </label>
            <textarea
              className="form-control text-black w-100"
              id="input-observations"
              placeholder="Escriba notas adicionales aquí..."
              style={{
                minHeight: 110,
                maxHeight: 110,
                borderRadius: 10,
              }}
              value={observations}
              onChange={(e) => onObservationsChange(e.target.value)}
            ></textarea>
          </div>
        </div>

        <div className="row g-3">
          <div className="col-md-6">
            <label htmlFor="hourType" className="form-label fw-bold mb-2">
              Referencia de interrupciones
            </label>
            <InterruptionReferenceSelector
              name=""
              label=""
              onChange={onReferenceChange}
              value={referenceTypeId}
            />

            <div className="checked-custom mt-3">
              <input
                className="form-check-input me-2"
                type="checkbox"
                value="extra"
                id="extra"
                checked={isExtra}
                onChange={(e) => onIsExtraChange(e.target.checked)}
                name="extra"
              />
              <label className="form-check-label fw-bold" htmlFor="extra">
                {labels.extraLabel}
              </label>
            </div>
          </div>

          <div className="col-md-6">
            <label htmlFor="hourType" className="form-label fw-bold mb-2">
              Buscar tipo de horas
            </label>
            <div className="d-flex align-items-end gap-2">
              <div className="position-relative flex-grow-1">
                <i
                  className="ri-search-line"
                  style={{
                    position: "absolute",
                    top: "18%",
                    left: 10,
                    color: "#9F9FA0",
                  }}
                ></i>
                <input
                  className="form-control text-dark"
                  style={{ paddingLeft: 25 }}
                  list="listHourType"
                  id="hourType"
                  placeholder={labels.selectHourTypePlaceholder}
                  onChange={onHourTypeChange}
                />
                <datalist id="listHourType">
                  {hourTypeList.map((type) => (
                    <option
                      key={type.id}
                      id={type.id.toString()}
                      value={type.abbreviature}
                      defaultValue={type.name}
                    />
                  ))}
                </datalist>
              </div>

              <button
                type="button"
                className="btn btn-primary flex-shrink-0"
                onClick={onAddHour}
              >
                + {labels.addButton}
              </button>
            </div>
          </div>
        </div>
      </div>

      <hr className="my-3 text-muted" />

      <div className="w-100">
        <table className="table table-borderless w-100 text-dark text-center mb-0">
          <thead className="table-light">
            <tr className="text-center fs-6">
              <th scope="col" className=" fw-bold">
                {labels.hourTypeLabel}
              </th>
              <th scope="col" className=" fw-bold">
                {labels.observationsTableLabel}
              </th>
              <th scope="col" className=" fw-bold">
                {labels.hoursLabel}
              </th>
              <th scope="col" className=" fw-bold">
                {labels.startLabel}
              </th>
              <th scope="col" className=" fw-bold">
                {labels.endLabel}
              </th>
              <th scope="col" className=" fw-bold">
                Referencia
              </th>
              <th scope="col" className=" fw-bold"></th>
            </tr>
          </thead>

          <tbody>
            {tableRows.map((row) => (
              <tr key={row.id}>
                <td className="text-primary">{row.hourTypeLabel}</td>
                <td style={{ maxWidth: 180 }}>
                  <span
                    className="d-inline-block text-truncate w-100"
                    title={row.observations || undefined}
                  >
                    {row.observations}
                  </span>
                </td>
                <td className="fw-bold">{row.hours}</td>
                <td>{row.startDisplay}</td>
                <td>{row.endDisplay}</td>
                <td>{row.referenceLabel}</td>
                <td>
                  <button
                    type="button"
                    onClick={() => onDeleteHour(row.id)}
                    style={{ padding: "1px 2px" }}
                    className="btn btn-danger btn-sm"
                  >
                    <i
                      className="ri-delete-bin-2-line p-0"
                      style={{ fontSize: 18 }}
                    ></i>
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        <div className="text-end my-2 text-dark">
          Total Registrado:{" "}
          <span className="fw-bold text-primary">{totalRegisteredHours}</span>{" "}
          Horas
        </div>
      </div>
    </div>
  );
};
